import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../../web/ReactQueryProvider';

export const CONVERSATIONS_QUERY_KEY = 'conversation/phoneNumber/{id}';

export const useConversationsInfiniteQuery = ({
	enabled = true,
	phoneNumberId,
	pageSize = 25,
	refetchOnWindowFocus,
	meta,
}: {
	enabled?: boolean;
	phoneNumberId: string;
	pageSize?: number;
	refetchOnWindowFocus?: boolean;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.IConversation>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageToken: pageParam, pageSize },
					urlPath: `conversation/phoneNumber/${phoneNumberId}`,
				}),
				'GET'
			);
		},
		queryKey: [CONVERSATIONS_QUERY_KEY, phoneNumberId, pageSize],
		refetchOnWindowFocus,
		initialPageParam: '',
		meta,
	});
};

export function invalidateConversations(phoneNumberId: string) {
	reactQueryClient.invalidateQueries({ queryKey: [CONVERSATIONS_QUERY_KEY, phoneNumberId] });
}
